import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const TopRow = styled.div`
  ${media.md`
    max-width: 350px;
  `}
`;

export const BottomRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  ${media.md`
    margin-top: 0px;
  `}
`;

export const ToggleExtraWrapper = styled.div`
  margin-left: 10px;
  ${media.md`
    width: 100px;
    display: flex;
  `}
`;
